import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  const styles = {
    container: {
      fontFamily: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      backgroundColor: '#0F172A',
      color: '#CBD5E1',
      minHeight: '100vh',
      WebkitFontSmoothing: 'antialiased',
      paddingBottom: '80px',
    },
    nav: {
      position: 'sticky',
      top: 0,
      width: '100%',
      zIndex: 50,
      backgroundColor: 'rgba(15, 23, 42, 0.85)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    },
    navInner: {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '16px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    logo: {
      fontSize: '1.35rem',
      fontWeight: '800',
      letterSpacing: '-0.03em',
      color: '#FFFFFF',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    logoAccent: {
      color: '#6366F1',
    },
    logoTag: {
      fontSize: '0.75rem',
      fontWeight: '600',
      color: '#94A3B8',
      backgroundColor: 'rgba(99, 102, 241, 0.12)',
      padding: '2px 8px',
      borderRadius: '6px',
      border: '1px solid rgba(99, 102, 241, 0.25)',
      marginLeft: '6px',
    },
    navLinks: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    navLink: (isActive) => ({
      fontSize: '0.875rem',
      fontWeight: '500',
      color: isActive ? '#FFFFFF' : '#94A3B8',
      textDecoration: 'none',
      padding: '6px 14px',
      borderRadius: '8px',
      backgroundColor: isActive ? 'rgba(79, 70, 229, 0.2)' : 'transparent',
      border: isActive ? '1px solid rgba(99, 102, 241, 0.4)' : '1px solid transparent',
      transition: 'all 0.2s ease',
    }),
    backLink: {
      fontSize: '0.875rem',
      color: '#94A3B8',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      padding: '6px 12px',
      borderRadius: '8px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
    },
    main: {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '56px 24px 0',
    },
    header: {
      textAlign: 'center',
      marginBottom: '48px',
    },
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '4px 14px',
      marginBottom: '20px',
      fontSize: '0.75rem',
      fontWeight: '700',
      letterSpacing: '0.06em',
      color: '#34D399',
      textTransform: 'uppercase',
      backgroundColor: 'rgba(52, 211, 153, 0.12)',
      borderRadius: '9999px',
      border: '1px solid rgba(52, 211, 153, 0.25)',
    },
    title: {
      fontSize: '2.75rem',
      fontWeight: '800',
      color: '#FFFFFF',
      marginBottom: '16px',
      letterSpacing: '-0.03em',
      lineHeight: '1.2',
    },
    gradientText: {
      background: 'linear-gradient(90deg, #10B981, #6366F1)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
    metaText: {
      color: '#94A3B8',
      fontSize: '0.95rem',
    },
    card: {
      backgroundColor: 'rgba(30, 41, 59, 0.6)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      borderRadius: '24px',
      padding: '44px',
      boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.5)',
    },
    section: {
      marginBottom: '40px',
    },
    sectionTitle: {
      fontSize: '1.4rem',
      fontWeight: '700',
      color: '#FFFFFF',
      marginBottom: '14px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      letterSpacing: '-0.02em',
    },
    p: {
      lineHeight: '1.75',
      marginBottom: '16px',
      color: '#CBD5E1',
      fontSize: '0.975rem',
    },
    ul: {
      listStyleType: 'disc',
      paddingLeft: '24px',
      marginBottom: '18px',
      lineHeight: '1.75',
      color: '#CBD5E1',
    },
    calloutBox: {
      padding: '24px',
      borderRadius: '16px',
      marginBottom: '24px',
      border: '1px solid',
    },
    calloutEmerald: {
      backgroundColor: 'rgba(16, 185, 129, 0.08)',
      borderColor: 'rgba(16, 185, 129, 0.25)',
      color: '#D1FAE5',
    },
    calloutIndigo: {
      backgroundColor: 'rgba(99, 102, 241, 0.08)',
      borderColor: 'rgba(99, 102, 241, 0.25)',
      color: '#E0E7FF',
    },
    calloutAmber: {
      backgroundColor: 'rgba(245, 158, 11, 0.08)',
      borderColor: 'rgba(245, 158, 11, 0.25)',
      color: '#FEF3C7',
    },
    calloutHeading: {
      fontSize: '1.05rem',
      fontWeight: '700',
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    tableWrapper: {
      overflowX: 'auto',
      marginBottom: '20px',
      borderRadius: '12px',
      border: '1px solid rgba(255, 255, 255, 0.08)',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      textAlign: 'left',
      fontSize: '0.9rem',
    },
    th: {
      backgroundColor: 'rgba(15, 23, 42, 0.8)',
      padding: '12px 16px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      color: '#FFFFFF',
      fontWeight: '600',
    },
    td: {
      padding: '12px 16px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
      color: '#CBD5E1',
    },
    footer: {
      textAlign: 'center',
      paddingTop: '36px',
      marginTop: '60px',
      borderTop: '1px solid rgba(255, 255, 255, 0.08)',
      fontSize: '0.875rem',
      color: '#64748B',
    },
    footerLinks: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
      marginTop: '12px',
    },
  };

  return (
    <div style={styles.container}>
      {/* Navigation */}
      <nav style={styles.nav}>
        <div style={styles.navInner}>
          <Link to="/" style={styles.logo}>
            <span>On<span style={styles.logoAccent}>Track</span></span>
            <span style={styles.logoTag}>FinOps & GreenOps</span>
          </Link>
          <div style={styles.navLinks}>
            <Link to="/terms" style={styles.navLink(false)}>Terms of Service</Link>
            <Link to="/privacy" style={styles.navLink(true)}>Privacy Policy</Link>
            <Link to="/" style={styles.backLink}>
              ← Back to App
            </Link>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main style={styles.main}>
        <header style={styles.header}>
          <div style={styles.badge}>Data Protection & Privacy Architecture</div>
          <h1 style={styles.title}>
            Privacy <span style={styles.gradientText}>Policy</span>
          </h1>
          <p style={styles.metaText}>
            Effective Date: September 10, 2026 &bull; Version 2.4 (Enterprise B2B)
          </p>
        </header>

        <div style={styles.card}>
          {/* Section 1 */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>1. Introduction and Scope</h2>
            <p style={styles.p}>
              At <strong>OnTrack S.R.L.</strong> ("<strong>OnTrack</strong>", "<strong>we</strong>", "<strong>us</strong>", or "<strong>our</strong>"),
              we hold data protection, infrastructure sovereignty, and cloud confidentiality as paramount values.
              This Privacy Policy details how we collect, process, store, and protect information when your organization
              interacts with our B2B Kubernetes FinOps & GreenOps SaaS platform, website, developer APIs, and lightweight Go telemetry daemon (collectively, the "<strong>Service</strong>").
            </p>
            <p style={styles.p}>
              This policy applies exclusively to business customers, IT administrators, devops engineers, and infrastructure telemetry streams.
              We operate strictly under a <strong>Zero-Payload Architecture</strong> designed to ensure that customer business data never leaves your Kubernetes boundary.
            </p>
          </section>

          {/* Section 2: Data Collected & Zero-Payload Guarantee */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>2. Information We Collect & The Zero-Payload Guarantee</h2>
            <p style={styles.p}>
              We limit data ingestion strictly to metadata necessary to compute infrastructure cost allocations, idle resource waste, and Scope 2 carbon emissions.
            </p>

            <div style={{ ...styles.calloutBox, ...styles.calloutEmerald }}>
              <div style={styles.calloutHeading}>
                <span>🛡️</span> Strict Zero-Payload Architecture
              </div>
              <p style={{ ...styles.p, color: '#D1FAE5', marginBottom: 0 }}>
                The OnTrack platform, Go telemetry agent, and processing workers <strong>DO NOT collect, process, or store</strong>:
                application payloads, request/response headers, customer database contents, internal network traffic, environment variables,
                Kubernetes Secrets, TLS certificates, or application source code. All metrics are aggregated numerical and structural metadata.
              </p>
            </div>

            <p style={styles.p}>Specifically, we collect two tiers of data:</p>
            <ul style={styles.ul}>
              <li>
                <strong>User Account Credentials:</strong> Business email address, authentication UID, and display name authenticated via <strong>Firebase Authentication</strong> (Google Workspace OAuth, Microsoft Entra ID, or email/password). We do not store raw account passwords.
              </li>
              <li>
                <strong>Cluster Telemetry Aggregates:</strong> Kubernetes workload metadata, including pod and container resource requests and limits (millicores, mebibytes), actual utilization figures from <code>metrics.k8s.io</code>, namespace labels, node machine instance types (e.g. <code>c2-standard-16</code>), cloud provider regions, and regional carbon intensity co-efficients (gCO2eq/kWh).
              </li>
            </ul>
          </section>

          {/* Section 3: Sub-Processors */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>3. Authorized Sub-Processors</h2>
            <p style={styles.p}>
              To deliver high-availability cloud intelligence, we engage enterprise sub-processors who adhere to rigorous SOC 2 Type II, ISO 27001, and GDPR compliance standards:
            </p>

            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Sub-Processor</th>
                    <th style={styles.th}>Role / Service Scope</th>
                    <th style={styles.th}>Data Entrusted</th>
                    <th style={styles.th}>Security Certification</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={styles.td}><strong>Google Cloud Platform (GCP)</strong></td>
                    <td style={styles.td}>Compute (Cloud Run), Database (Cloud SQL PostgreSQL), and ML Heuristics (Vertex AI).</td>
                    <td style={styles.td}>Cluster telemetry aggregates, cost recommendations, encrypted configuration.</td>
                    <td style={styles.td}>SOC 1/2/3, ISO 27001, FedRAMP, HIPAA compliant.</td>
                  </tr>
                  <tr>
                    <td style={styles.td}><strong>Firebase Auth (Google)</strong></td>
                    <td style={styles.td}>Identity management, session token issuance, and multi-factor authentication.</td>
                    <td style={styles.td}>User email, Firebase UID, session tokens.</td>
                    <td style={styles.td}>ISO 27001, SOC 2 Type II.</td>
                  </tr>
                  <tr>
                    <td style={styles.td}><strong>Paddle.com Inc.</strong></td>
                    <td style={styles.td}>Merchant of Record, subscription billing, checkout processing, and tax remittance.</td>
                    <td style={styles.td}>Billing contacts, subscription tier, corporate entity name, payment records.</td>
                    <td style={styles.td}>PCI-DSS Level 1 Service Provider.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Section 4: Automated Data Retention */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>4. Automated Data Retention & Lifecycle Purging</h2>
            <p style={styles.p}>
              We implement automated retention lifecycle policies that systematically purge historical cluster telemetry based on your organization's subscription tier:
            </p>
            <ul style={styles.ul}>
              <li>
                <strong>Developer Tier:</strong> High-resolution telemetry is retained on a rolling <strong>14-day window</strong>. Data older than 14 days is automatically deleted by Cloud SQL lifecycle workers.
              </li>
              <li>
                <strong>Team / Pro Tier:</strong> Telemetry and optimization recommendation histories are retained on a rolling <strong>90-day window</strong>.
              </li>
              <li>
                <strong>Enterprise Tier:</strong> Telemetry is maintained on a rolling <strong>365-day window</strong> (or custom retention schedules negotiated in an Enterprise SLA).
              </li>
              <li>
                <strong>Account Deletion:</strong> Upon customer request or subscription termination, all associated cluster tokens are permanently revoked, and telemetry tables are completely purged within thirty (30) days.
              </li>
            </ul>
          </section>

          {/* Section 5: Zero Data Selling */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>5. Zero Data Selling & Commercialization Prohibition</h2>
            
            <div style={{ ...styles.calloutBox, ...styles.calloutIndigo }}>
              <div style={styles.calloutHeading}>
                <span>🚫</span> Zero Data Monetization or Selling Guarantee
              </div>
              <p style={{ ...styles.p, color: '#E0E7FF', marginBottom: 0 }}>
                OnTrack adheres to an unequivocal policy: <strong>We do not sell, rent, lease, barter, or trade customer telemetry, usage patterns, or account data to third parties, advertising brokers, or data aggregators.</strong>
                Furthermore, customer telemetry is <strong>NEVER</strong> utilized to train, tune, or improve generalized public AI foundation models.
              </p>
            </div>
          </section>

          {/* Section 6: Data Subject Rights */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>6. Data Subject Rights (GDPR & CCPA/CPRA)</h2>
            <p style={styles.p}>
              In accordance with the General Data Protection Regulation (GDPR), the California Consumer Privacy Act (CCPA), and applicable international privacy frameworks, Customers and individual users possess the following rights:
            </p>
            <ul style={styles.ul}>
              <li>
                <strong>Right to Access & Inspection:</strong> You may request a complete report of personal and cluster metadata linked to your account.
              </li>
              <li>
                <strong>Right to Data Portability:</strong> You may export raw cluster telemetry history and generated FinOps audit logs in standard structured formats (JSON/CSV).
              </li>
              <li>
                <strong>Right to Rectification:</strong> You may correct inaccurate or outdated administrative contact information directly via the dashboard.
              </li>
              <li>
                <strong>Right to Erasure ("Right to be Forgotten"):</strong> You may request total purging of your user credentials and cluster telemetry records.
              </li>
              <li>
                <strong>Right to Restrict or Object to Processing:</strong> You may revoke cluster agent tokens at any time, immediately halting all telemetry ingestion from your Kubernetes environments.
              </li>
            </ul>
            <p style={styles.p}>
              To exercise any of these rights, email our Data Protection team at <a href="mailto:privacy@on-track-app.com" style={{ color: '#818CF8' }}>privacy@on-track-app.com</a>. Requests are fulfilled within thirty (30) days.
            </p>
          </section>

          {/* Section 7: Security Architecture */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>7. Enterprise Security Architecture</h2>
            <p style={styles.p}>
              OnTrack enforces multi-layered defense-in-depth security across all infrastructure tiers:
            </p>
            <ul style={styles.ul}>
              <li>
                <strong>Transport Encryption (TLS 1.3):</strong> All telemetry streamed from Kubernetes Go agents to ingestion workers is strictly enforced over TLS 1.3 with forward secrecy. Insecure plaintext HTTP connections are rejected at the edge.
              </li>
              <li>
                <strong>Application-Layer Encryption (Cloud KMS):</strong> Data at rest within Cloud SQL PostgreSQL is protected using Google Cloud Key Management Service (Cloud KMS) envelope encryption with 256-bit AES keys.
              </li>
              <li>
                <strong>Cryptographic Key Hashing:</strong> Cluster agent tokens and API authentication secrets are hashed using one-way <strong>SHA-256</strong> with salt before storage. Plaintext keys are never stored in databases or logged.
              </li>
              <li>
                <strong>VPC Isolation:</strong> Backend microservices and databases communicate via private Google Cloud VPC Service Controls with private IP peering, preventing direct public internet exposure of database endpoints.
              </li>
            </ul>
          </section>

          {/* Section 8: Changes & Contact */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>8. Changes to this Policy & Contact Information</h2>
            <p style={styles.p}>
              We may update this Privacy Policy periodically to reflect technological evolutions or regulatory revisions.
              Material modifications will be notified via email to account administrators or posted prominently across the Service prior to becoming effective.
            </p>
            <p style={styles.p}>
              If you have any questions, concerns, or inquiries regarding this Privacy Policy or our security architecture, please contact:
            </p>
            <div style={{ ...styles.calloutBox, backgroundColor: 'rgba(255, 255, 255, 0.03)', borderColor: 'rgba(255, 255, 255, 0.08)' }}>
              <p style={{ margin: '0 0 6px 0', color: '#FFFFFF', fontWeight: '600' }}>
                OnTrack S.R.L. &bull; Data Protection Officer
              </p>
              <p style={{ margin: '0 0 6px 0', color: '#818CF8', fontWeight: '500' }}>
                privacy@on-track-app.com
              </p>
              <p style={{ margin: 0, color: '#94A3B8', fontSize: '0.875rem' }}>
                Corporate Headquarters &bull; San José, Costa Rica
              </p>
            </div>
          </section>
        </div>

        {/* Footer */}
        <footer style={styles.footer}>
          <p>&copy; 2026 OnTrack S.R.L. All rights reserved. Enterprise B2B FinOps & GreenOps Platform.</p>
          <div style={styles.footerLinks}>
            <Link to="/terms" style={{ color: '#94A3B8', textDecoration: 'none' }}>Terms of Service</Link>
            <span style={{ color: '#475569' }}>&bull;</span>
            <Link to="/privacy" style={{ color: '#34D399', textDecoration: 'none' }}>Privacy Policy</Link>
            <span style={{ color: '#475569' }}>&bull;</span>
            <a href="mailto:privacy@on-track-app.com" style={{ color: '#94A3B8', textDecoration: 'none' }}>Contact Privacy Officer</a>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
